// extracted by mini-css-extract-plugin
module.exports = {"page-secondary-color":"#FFFFFF","pageSecondaryColor":"#FFFFFF","carousel":"_20Ueu","carouselImage":"_3xGZF"};